export default {
  languages: {},
  active: null
}
